/**
 * Size selector and quick add cart functionality for product grid items
 * Combined version of both size-selector.js and size-selector-fix.js
 */
document.addEventListener('DOMContentLoaded', function() {  // Initialize all size selectors on the page
  initSizeSelectors();
  
  // Validate and fix form structures
  validateFormStructure();
    // Force all quick add buttons to be clickable if a size is selected
  function makeButtonsClickable() {
    // First, verify and fix any variant ID mismatches
    verifyAndFixVariantIds();
    
    document.querySelectorAll('.size-option.selected').forEach(function(selectedOption) {
      const productId = selectedOption.getAttribute('data-size-option');
      const container = selectedOption.closest('.product-item');
      if (container) {
        const button = container.querySelector('.quick_add--size');
        const input = container.querySelector('[data-variant-id-input]');
        const variantId = selectedOption.getAttribute('data-variant-id');
        if (button && input) {
          // Enable the button
          button.disabled = false;
          button.classList.add('is-active');
          button.style.opacity = '1';
          button.style.pointerEvents = 'auto';
          button.style.cursor = 'pointer';
          // Only set the input value, do not auto-click ATC here
          if (variantId) {
            input.value = variantId;
          }
        }
      }
    });
    
    // Fix for all buttons to make sure they're clickable when a size is selected
    document.querySelectorAll('.size-quick-add-form').forEach(function(form) {
      const input = form.querySelector('[data-variant-id-input]');
      const button = form.querySelector('.quick_add--size');
      
      if (input && button && input.value) {
        button.disabled = false;
        button.classList.add('is-active');
        button.style.opacity = '1';
        button.style.pointerEvents = 'auto';
        button.style.cursor = 'pointer';
      }
    });
  }
  // Re-initialize size selectors when the DOM changes (for infinite scroll or dynamically loaded content)
  if (window.MutationObserver) {
    let observerTimeout;
    const observer = new MutationObserver(function(mutations) {
      let shouldReinit = false;
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          // Check if any added nodes contain product selectors
          for (let node of mutation.addedNodes) {
            if (node.nodeType === 1 && (node.classList.contains('product-item') || node.querySelector('.product-size-selector'))) {
              shouldReinit = true;
              break;
            }
          }
        }
      });
      
      if (shouldReinit) {
        clearTimeout(observerTimeout);
        observerTimeout = setTimeout(function() {
          initSizeSelectors();
          makeButtonsClickable();
        }, 300);
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  // Run on page load
  setTimeout(makeButtonsClickable, 500);
    // Store product data globally
  if (!window.productData) {
    window.productData = {};
  }
  
  // Global error tracking to prevent spam
  if (!window.sizeErrorTracker) {
    window.sizeErrorTracker = {
      lastError: 0,
      errorCount: 0
    };
  }
  
  // Function to show error only if not shown recently
  function showSizeError(context = 'general') {
    const now = Date.now();
    const timeSinceLastError = now - window.sizeErrorTracker.lastError;
    
    // Only show error if it's been more than 3 seconds since last error
    if (timeSinceLastError > 3000) {
      console.log('Please select a size first');
      window.sizeErrorTracker.lastError = now;
      window.sizeErrorTracker.errorCount = 1;
    } else {
      window.sizeErrorTracker.errorCount++;
      // If too many errors in short time, stop showing them
      if (window.sizeErrorTracker.errorCount > 5) {
        console.warn('Too many size selection errors - stopping notifications');
        return false;
      }
    }
    return true;
  }

  function initSizeSelectors() {
    // Find all size option elements on the page
    const sizeOptions = document.querySelectorAll('.size-option:not([data-initialized])');
    
    sizeOptions.forEach(function(option) {
      // Mark as initialized to prevent duplicate event listeners
      option.setAttribute('data-initialized', 'true');
      
      if (option.classList.contains('sold-out')) {
        return; // Skip sold out options
      }
      
      const productId = option.getAttribute('data-size-option');
      const optionIndex = parseInt(option.getAttribute('data-option-index'));
      const sizeValue = option.getAttribute('data-size-value');
        option.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        console.log('Size option clicked:', sizeValue, 'for product:', productId);
        
        // Remove selected class from all options in the same group
        const optionsContainer = option.closest('.size-options');
        const allOptions = optionsContainer.querySelectorAll('.size-option');
        allOptions.forEach(opt => opt.classList.remove('selected'));

        // Add selected class to clicked option
        option.classList.add('selected');

        // Add is-loading class to parent wrapper
        if (optionsContainer) {
          optionsContainer.classList.add('is-loading');
        }
        
        // IMMEDIATE: Try to get variant ID from the HTML data attribute first
        const directVariantId = option.getAttribute('data-variant-id');
        const sizeSelector = option.closest('.product-item');
        
        if (directVariantId && sizeSelector) {
          // Update the form immediately with the variant ID from HTML
          const form = sizeSelector.querySelector('form');
          if (form) {
            const input = form.querySelector('[data-variant-id-input]') || 
                         form.querySelector('input[name="id"]');
            if (input) {
              input.value = directVariantId;
              debugVariantIdUpdate(productId, 'Immediate HTML Update', directVariantId);
              console.log('Immediate variant ID update:', directVariantId);
              // Enable the button immediately
              const button = form.querySelector('.quick_add--size');
              if (button) {
                button.disabled = false;
                button.classList.add('is-active');
                button.style.opacity = '1';
                button.style.pointerEvents = 'auto';
                button.style.cursor = 'pointer';
                console.log('Button enabled immediately');
              }
          // Show loader at the end of the size box grid by changing opacity
          const optionsContainer = option.closest('.size-options');
          const loader = optionsContainer ? optionsContainer.querySelector('.size-options__loader') : null;
          if (loader) loader.style.opacity = '1';
              // Auto-click ATC button only when user selects a size
              const atc = sizeSelector.querySelector('.quick_add');
              if (atc) {
                atc.click();
                // Remove selected class and hide loader after click
                setTimeout(function() {
                  if (optionsContainer) {
                    optionsContainer.querySelectorAll('.size-option.selected').forEach(function(opt) {
                      opt.classList.remove('selected');
                    });
                    if (loader) loader.style.opacity = '0';
                    optionsContainer.classList.remove('is-loading');
                  }
                }, 1000);
              }
            }
          }
        }
        
        // FALLBACK: Use the async product data method as backup
        if (!window.productData[productId]) {
          fetchProductData(productId, function(product) {
            window.productData[productId] = product;
            updateVariantFromSizeOption(product, sizeValue, optionIndex, productId);
          });
        } else {
          updateVariantFromSizeOption(window.productData[productId], sizeValue, optionIndex, productId);
        }
        
        // Ensure the container stays visible
        if (sizeSelector) {
          sizeSelector.style.opacity = '1';
          sizeSelector.style.pointerEvents = 'auto';
        }
        
        // Log for debugging
        console.log('Size selected:', sizeValue, 'for product:', productId);
        
        // Run makeButtonsClickable after a delay
        setTimeout(makeButtonsClickable, 100);
        
        return false;
      });
    });
    
    // Make sure the quick add form submits properly
    const quickAddForms = document.querySelectorAll('.size-quick-add-form:not([data-form-initialized])');
    quickAddForms.forEach(function(form) {
      form.setAttribute('data-form-initialized', 'true');      form.addEventListener('submit', function(e) {
        const variantIdInput = form.querySelector('[data-variant-id-input]') || 
                              form.querySelector('input[name="id"]') ||
                              form.querySelector('input[type="hidden"]');
        
        console.log('Form submit attempt - Input found:', !!variantIdInput);
        console.log('Input value:', variantIdInput ? variantIdInput.value : 'No input');
        console.log('Input name:', variantIdInput ? variantIdInput.name : 'No input');
        
        if (!variantIdInput || !variantIdInput.value || variantIdInput.value === '' || variantIdInput.value === '0') {
          e.preventDefault();
          e.stopPropagation();
          
          console.error('Form submission blocked - Missing or invalid variant ID');
          
          // Use global error tracker
          showSizeError('form-submit');
          return false;
        }
        
        // Validate that the variant ID is a valid number
        const variantId = parseInt(variantIdInput.value);
        if (isNaN(variantId) || variantId <= 0) {
          e.preventDefault();
          e.stopPropagation();
          console.error('Form submission blocked - Invalid variant ID format:', variantIdInput.value);
          showSizeError('form-submit');
          return false;
        }
        
        // Ensure the form has the correct action and method
        if (!form.action || form.action.indexOf('/cart/add') === -1) {
          if (!form.action) {
            form.action = '/cart/add';
          }
          if (!form.method) {
            form.method = 'POST';
          }
        }
        
        // Add additional required fields if missing
        if (!form.querySelector('input[name="quantity"]')) {
          const qtyInput = document.createElement('input');
          qtyInput.type = 'hidden';
          qtyInput.name = 'quantity';
          qtyInput.value = '1';
          form.appendChild(qtyInput);
        }
        
        console.log('Form submitting with variant ID:', variantIdInput.value);
        console.log('Form action:', form.action);
        console.log('Form method:', form.method);
      });
    });
  }
  function updateVariantFromSizeOption(product, selectedSize, optionIndex, productId) {
    if (!product || !product.variants) {
      console.error('Product or variants data missing:', product);
      return;
    }
    
    console.log('Looking for variant with size:', selectedSize, 'at option index:', optionIndex);
    console.log('Available variants:', product.variants);
    
    // Find the variant that matches the selected size
    let selectedVariant = null;
    
    for (const variant of product.variants) {
      console.log('Checking variant:', variant.id, 'options:', variant.options, 'available:', variant.available);
      if (variant.options[optionIndex] === selectedSize && variant.available) {
        selectedVariant = variant;
        break;
      }
    }
    
    if (selectedVariant) {
      console.log('Selected variant found:', selectedVariant);
      
      // Try multiple ways to find the input field
      let variantIdInput = document.querySelector(`[data-variant-id-input="${productId}"]`);
      
      // If not found, try alternative selectors
      if (!variantIdInput) {
        const container = document.querySelector(`[data-product-size-selector="${productId}"]`);
        if (container) {
          variantIdInput = container.querySelector('[data-variant-id-input]') ||
                          container.querySelector('input[name="id"]') ||
                          container.querySelector('input[type="hidden"]');
        }
      }
        if (variantIdInput) {
        // Ensure the variant ID is properly formatted
        const variantId = String(selectedVariant.id);
        variantIdInput.value = variantId;
        
        // Debug the update
        debugVariantIdUpdate(productId, 'Async Product Data Update', variantId);
        
        // Also set the name attribute if it's missing
        if (!variantIdInput.name) {
          variantIdInput.name = 'id';
        }
        
        console.log('Variant ID set:', variantId, 'Input name:', variantIdInput.name);
        
        // Enable the add to cart button
        const addToCartBtn = variantIdInput.closest('form').querySelector('.quick_add--size');
        if (addToCartBtn) {
          addToCartBtn.disabled = false;
          
          // Ensure the button is properly styled as enabled
          addToCartBtn.classList.add('is-active');
          addToCartBtn.style.pointerEvents = 'auto';
          addToCartBtn.style.opacity = '1';
          
          // Add form validation attributes
          const form = addToCartBtn.closest('form');
          if (form) {
            form.setAttribute('data-variant-selected', 'true');
            form.setAttribute('data-variant-id', variantId);
          }
          
          console.log('Button enabled for variant ID:', variantId);
        } else {
          console.warn('Add to cart button not found');
        }
      } else {
        console.error('Variant ID input not found for product:', productId);
        // Try to create the input if it doesn't exist
        const container = document.querySelector(`[data-product-size-selector="${productId}"]`);
        if (container) {
          const form = container.querySelector('form');
          if (form) {
            const newInput = document.createElement('input');
            newInput.type = 'hidden';
            newInput.name = 'id';
            newInput.setAttribute('data-variant-id-input', productId);
            newInput.value = String(selectedVariant.id);
            form.appendChild(newInput);
            console.log('Created missing variant input with ID:', selectedVariant.id);
          }
        }
      }
    } else {
      console.error('No available variant found for size:', selectedSize);
      console.log('Available variants for debugging:', product.variants.map(v => ({
        id: v.id,
        options: v.options,
        available: v.available
      })));
    }
  }

  function fetchProductData(productId, callback) {
    const productHandle = getProductHandleFromId(productId);
    if (!productHandle) return;
    
    fetch(`/products/${productHandle}.js`)
      .then(response => response.json())
      .then(product => {
        callback(product);
      })
      .catch(error => {
        console.error('Error fetching product data:', error);
      });
  }

  function getProductHandleFromId(productId) {
    // Try to get the handle from a link near the size selector
    const productContainer = document.querySelector(`[data-product-size-selector="${productId}"]`);
    if (productContainer) {
      // Look for product link within the same product container
      const productLink = productContainer.closest('.product-item').querySelector('[data-product-link]');
      if (productLink) {
        const url = productLink.getAttribute('href') || productLink.getAttribute('data-product-link');
        if (url) {
          const handleMatch = url.match(/\/products\/([^/?#]+)/);
          if (handleMatch && handleMatch[1]) {
            return handleMatch[1];
          }
        }
      }
    }
    
    return null;
  }
  
  // Make buttons clickable when hovering over product
  document.querySelectorAll('.product-item').forEach(function(item) {
    const sizeSelector = item.querySelector('.product-size-selector');
    const quickAddBtn = item.querySelector('.quick_add');
    
    if (sizeSelector && quickAddBtn) {
      // Show size selector when hovering over the quick add button
      quickAddBtn.addEventListener('mouseenter', function() {
        sizeSelector.style.opacity = '1';
        sizeSelector.style.pointerEvents = 'auto';
      });
      
      item.addEventListener('mouseenter', function() {
        setTimeout(makeButtonsClickable, 100);
      });
    }
  });
  
  // Direct click handler through event delegation
  document.body.addEventListener('click', function(event) {    // Handle clicks on quick add buttons
    if (event.target.classList.contains('quick_add--size') || 
        event.target.closest('.quick_add--size')) {
      // Get the button
      const button = event.target.classList.contains('quick_add--size') ? 
                     event.target : 
                     event.target.closest('.quick_add--size');
      
      // Prevent multiple rapid clicks
      if (button.dataset.processing === 'true') {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
        // Get the form
      const form = button.closest('form');
      if (form) {
        const input = form.querySelector('[data-variant-id-input]') || 
                     form.querySelector('input[name="id"]') ||
                     form.querySelector('input[type="hidden"]');
        
        console.log('Button click - Form found:', !!form);
        console.log('Button click - Input found:', !!input);
        console.log('Button click - Input value:', input ? input.value : 'No input');
        
        if (!input || !input.value || input.value === '' || input.value === '0') {
          event.preventDefault();
          event.stopPropagation();
          
          console.error('Button click blocked - Missing or invalid variant ID');
          
          // Use global error tracker
          showSizeError('button-click');
          return false;
        }
        
        // Validate variant ID format
        const variantId = parseInt(input.value);
        if (isNaN(variantId) || variantId <= 0) {
          event.preventDefault();
          event.stopPropagation();
          console.error('Button click blocked - Invalid variant ID format:', input.value);
          showSizeError('button-click');
          return false;
        }
        
        // Mark as processing to prevent multiple clicks
        button.dataset.processing = 'true';
        setTimeout(function() {
          delete button.dataset.processing;
        }, 1000);
        
        // Make sure the button is enabled
        button.disabled = false;
        button.classList.add('is-active');
        
        console.log('Add to cart clicked, variant ID:', input.value);
      }
    }
      // Handle clicks on size options (backup handler)
    if (event.target.classList.contains('size-option') && 
        !event.target.classList.contains('sold-out')) {
      
      const selectedSize = event.target.getAttribute('data-size-value');
      const productId = event.target.getAttribute('data-size-option');
      const optionIndex = parseInt(event.target.getAttribute('data-option-index'));
      const variantId = event.target.getAttribute('data-variant-id');
      
      console.log('Backup click handler triggered for size:', selectedSize);
      
      // Remove selected class from all siblings
      const siblings = event.target.parentElement.querySelectorAll('.size-option');
      siblings.forEach(sibling => sibling.classList.remove('selected'));
      
      // Add selected class to clicked option
      event.target.classList.add('selected');
      
      // Find the form and button
      const container = event.target.closest('.product-size-selector');
      if (container) {
        const form = container.querySelector('form');
        if (form) {
          const input = form.querySelector('[data-variant-id-input]') ||
                       form.querySelector('input[name="id"]');
          const button = form.querySelector('.quick_add--size');
          
          if (input && button) {
            // Set variant ID from data attribute or use fallback
            if (variantId) {
              input.value = variantId;
              console.log('Backup handler set variant ID:', variantId);
            } else {
              console.log('No variant ID in data attribute, using async fetch');
            }
            
            // Force enable the button
            button.disabled = false;
            button.classList.add('is-active');
            button.style.opacity = '1';
            button.style.pointerEvents = 'auto';
            button.style.cursor = 'pointer';
            
            console.log('Button enabled through backup handler for:', productId);
          }
        }
      }
      
      setTimeout(makeButtonsClickable, 100);
    }
  });  
  // Run makeButtonsClickable periodically but less frequently
  let buttonCheckInterval = setInterval(function() {
    // Only run if there are products on the page
    if (document.querySelector('.product-size-selector')) {
      makeButtonsClickable();
    } else {
      // Clear interval if no products found (e.g., user navigated away)
      clearInterval(buttonCheckInterval);
    }
  }, 5000); // Reduced from 1000ms to 5000ms

  // Function to validate and fix form structure
  function validateFormStructure() {
    const productSelectors = document.querySelectorAll('.product-size-selector');
    
    productSelectors.forEach(function(selector) {
      const productId = selector.getAttribute('data-product-size-selector');
      let form = selector.querySelector('form');
      
      if (!form) {
        console.warn('No form found in product selector for product:', productId);
        return;
      }
      
      // Check if form has proper action
      if (!form.action || form.action.indexOf('/cart/add') === -1) {
        form.action = '/cart/add';
        form.method = 'POST';
        console.log('Fixed form action for product:', productId);
      }
      
      // Check for variant ID input
      let variantInput = form.querySelector('[data-variant-id-input]') ||
                        form.querySelector('input[name="id"]');
      
      if (!variantInput) {
        variantInput = document.createElement('input');
        variantInput.type = 'hidden';
        variantInput.name = 'id';
        variantInput.setAttribute('data-variant-id-input', productId);
        form.appendChild(variantInput);
        console.log('Created missing variant input for product:', productId);
      }
      
      // Check for quantity input
      if (!form.querySelector('input[name="quantity"]')) {
        const qtyInput = document.createElement('input');
        qtyInput.type = 'hidden';
        qtyInput.name = 'quantity';
        qtyInput.value = '1';
        form.appendChild(qtyInput);
        console.log('Added quantity input for product:', productId);
      }
      
      // Add CSRF token if missing (for Shopify)
      if (!form.querySelector('input[name="form_type"]')) {
        const formTypeInput = document.createElement('input');
        formTypeInput.type = 'hidden';
        formTypeInput.name = 'form_type';
        formTypeInput.value = 'product';
        form.appendChild(formTypeInput);
      }
    });
  }

  // Initial validation of form structure
  validateFormStructure();

  // Debug function to track variant ID updates
  function debugVariantIdUpdate(productId, action, variantId) {
    const container = document.querySelector(`[data-product-size-selector="${productId}"]`);
    if (container) {
      const form = container.querySelector('form');
      const input = form ? (form.querySelector('[data-variant-id-input]') || form.querySelector('input[name="id"]')) : null;
      const selectedSize = container.querySelector('.size-option.selected');
      
      console.group(`🔍 Variant ID Debug - ${action}`);
      console.log('Product ID:', productId);
      console.log('Expected Variant ID:', variantId);
      console.log('Input Found:', !!input);
      console.log('Current Input Value:', input ? input.value : 'No input');
      console.log('Selected Size Element:', selectedSize ? selectedSize.getAttribute('data-size-value') : 'None');
      console.log('Size Element Variant ID:', selectedSize ? selectedSize.getAttribute('data-variant-id') : 'None');
      console.groupEnd();
    }
  }
  
  // Function to verify and fix variant ID mismatches
  function verifyAndFixVariantIds() {
    const selectedOptions = document.querySelectorAll('.size-option.selected');
    
    selectedOptions.forEach(function(option) {
      const productId = option.getAttribute('data-size-option');
      const expectedVariantId = option.getAttribute('data-variant-id');
      
      if (expectedVariantId) {
        const container = option.closest('.product-size-selector');
        if (container) {
          const form = container.querySelector('form');
          if (form) {
            const input = form.querySelector('[data-variant-id-input]') ||
                         form.querySelector('input[name="id"]');
            
            if (input) {
              if (input.value !== expectedVariantId) {
                console.warn(`🔧 Fixing variant ID mismatch for product ${productId}`);
                console.log(`Expected: ${expectedVariantId}, Found: ${input.value}`);
                input.value = expectedVariantId;
                debugVariantIdUpdate(productId, 'Mismatch Fix', expectedVariantId);
              }
            }
          }
        }
      }
    });
  }

  // Run variant ID verification periodically
  setInterval(verifyAndFixVariantIds, 5000);
  
  // Watch for input value changes
  function observeInputChanges() {
    const inputs = document.querySelectorAll('input[name="id"], [data-variant-id-input]');
    
    inputs.forEach(function(input) {
      if (!input.hasAttribute('data-observed')) {
        input.setAttribute('data-observed', 'true');
        
        // Watch for value changes
        const observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
              console.log('Input value changed:', input.value);
            }
          });
        });
        
        observer.observe(input, {
          attributes: true,
          attributeFilter: ['value']
        });
        
        // Also listen for direct value changes
        input.addEventListener('input', function() {
          console.log('Input event fired, new value:', input.value);
        });
      }
    });
  }
  
  // Run input observation
  setTimeout(observeInputChanges, 1000);
});